<script lang="ts" setup>
  import * as locales from '@nuxt/ui/locale'

  // Idioma
  const { locale, setLocale, availableLocales } = useI18n()
  
  // Filtrar locales de Nuxt UI para mostrar solo los configurados en i18n
  const filteredLocales = computed(() => {
    type LocCode = 'es' | 'en' | 'de' | 'it' | 'fr'
    return Object.values(locales).filter((loc) =>
      availableLocales.includes(loc.code as LocCode)
    )
  })

  // Ordenar locales
  const orderLocales = {
    es: 1,
    en: 2,
    de: 3,
    it: 4,
    fr: 5
  }

  filteredLocales.value.sort((a, b) => {
    return orderLocales[a.code as keyof typeof orderLocales] - orderLocales[b.code as keyof typeof orderLocales]
  })

  // Manejar cambio de idioma
  const handleLocaleChange = async (newLocale: string | undefined) => {
    if (!newLocale) return
    const localeCode = newLocale as 'es' | 'en' | 'de' | 'it' | 'fr'
    await setLocale(localeCode)
  }
</script>

<template>
  <ULocaleSelect
    :model-value="locale"
    :locales="filteredLocales"
    @update:model-value="handleLocaleChange"
  />
</template>